import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-10 px-4" data-id="element-288">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-289">
        <div className="flex flex-col items-center justify-center" data-id="element-290">
          <UsersIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-291" />
          <span className="text-3xl font-black mb-1" data-id="element-292">+500</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-293">
            docentes
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-294">
          <BookOpenIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-295" />
          <span className="text-3xl font-black mb-1" data-id="element-296">6</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-297">
            Tomos listos
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-298">
          <div className="flex text-yellow-400 mb-3" data-id="element-299">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-300" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-301" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-302" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-303" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-304" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-305">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-306">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-307">
          <MapPinIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-308" />
          <span className="text-3xl font-black mb-1" data-id="element-309">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-310">
            Todo el país
            <br data-id="element-311" />
            secundaria 1° a 6°
          </span>
        </div>
      </div>
    </section>;
}